export default {
  INDEXED_COLUMNS: {},
  props: {
    config: {
      type: Object,
      default: _.stubObject
    }
  },
  created () {
    this.fetchData = _.debounce(this.fetchData, 250)
    return this.fetchData()
  },
  data () {
    return {
      data: [],
      loading: false,
      query: '',
      selection: []
    }
  },
  computed: {
    filters () {
      return this.config.filters
    },
    columns () {
      return _.toArray(this.config.columns || []).map((c) => ({
        align: 'left',
        ...this.$options.INDEXED_COLUMNS[c] || {}
      }))
    },
    fetchOptions () {
      const { query, config: { pagination, filters } } = this
      const { page, sortBy, rowsPerPage, descending } = pagination || {}
      const opt = {
        query,
        limit: rowsPerPage,
        page,
        ascending: descending ? 0 : 1,
        orderBy: sortBy
      }
      return {
        ...opt,
        filters
      }
    }
  },
  watch: {
    fetchOptions: {
      deep: true,
      handler (v) {
        this._fetchOptionsHandler(v)
      }
    }
  },
  methods: {
    async _fetchOptionsHandler (v) {
      if (!_.isEqual(v, this.prevFetchOptions)) {
        await this.fetchData()
      }
      this.prevFetchOptions = _.cloneDeep(v)
    },
    _fetchData () {
      if (!this.staticData) console.warn('Vous devriez surcharger la methode "_fetchData"')
    },
    onRequest (props) {
      if (this.staticData) return
      const { filter, pagination } = props
      this.config.pagination = pagination
      this.query = filter
    },
    async fetchData () {
      if (this.staticData) return
      this.loading = true
      try {
        const r = await this._fetchData(this.fetchOptions)
        if (r.data) {
          this.data = r.data
          this.$set(this.config, 'pagination', {
            ...this.config.pagination || {},
            rowsNumber: +r.filtered || +r.recordsFiltered || 0
          })
        } else {
          this.data = r
        }
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    }
  }
}
